import { Box, Typography } from "@mui/material";
import { memo } from "react";

interface BarCellProps {
  value: number;
  maxValue: number;
  formattedValue: string;
  color: string;
}

export const BarCell = memo(function ProgressBar({
  value,
  maxValue,
  formattedValue,
  color,
}: BarCellProps) {
  const barWidthPercent = value > 0 ? (value / maxValue) * 100 : 0;

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: 26,
        borderRadius: "2px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          lineHeight: "24px",
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          pr: 1,
          zIndex: 1,
        }}
      >
        <Typography
          component="span"
          variant="body1"
          sx={{ lineHeight: "inherit" }}
        >
          {formattedValue}
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: `${barWidthPercent}%`,
          backgroundColor: color,
          height: "100%",
          border: 1,
          borderColor: "divider",
          borderRadius: "2px",
        }}
      />
    </Box>
  );
});
